// extracted by mini-css-extract-plugin
export default {"message":"PopupMessage_message__Hpvt8"};